import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';

import ToolbarSocial from './ToolbarSocial';
import ToolbarSettings from './ToolbarSettings';
import { AppSettingsContext } from 'AppSettingsContext';
import { Wrapper, Container, Box, Item } from './Toolbar.style';

function Toolbar({ widgets = { left: [], right: [] } }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);
  return (
    <Wrapper theme={theme.toolbar.wrapper}>
      <Box>
        <Item theme={theme.toolbar.item.left}>
          <Container
            isLeft={true}
            widerTheme={appSettings.theme === 6 ? String(true) : undefined}
            narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
          >
            <ToolbarSocial widgets={widgets.left} />
          </Container>
        </Item>
        <Item theme={theme.toolbar.item.right}>
          <Container
            isRight={true}
            widerTheme={appSettings.theme === 6 ? String(true) : undefined}
            narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
          >
            <ToolbarSettings widgets={widgets.right} />
          </Container>
        </Item>
      </Box>
    </Wrapper>
  );
}

export default Toolbar;
